<template>
  <b-container fluid>
    <b-row>
      <b-col cols="9"><div class="card">
        <div class="card-header">
          Manifest Items
        </div>
        <div class="card-body">
          <b-list-group flush class="entity-list-group">
            <b-list-group-item v-for="entity in cartItems" :key="entity.entityId" class="m-0 p-0">
              <entity-list-group-item :entity="entity"></entity-list-group-item>
            </b-list-group-item>
            <div v-if="cartItems.length === 0" class="text-center p-3">
              No items in the cart.
            </div>
          </b-list-group>
        </div>
      </div></b-col>
      <b-col cols="3"><div class="card">
        <div class="card-header">
          Manifest Summary
        </div>
        <div class="card-body">
          <b-row>
            <b-col>Number Items</b-col>
            <b-col>{{ cartItems.length }}</b-col>
          </b-row>
          <b-row>
            <b-col>Total Size</b-col>
            <b-col>{{ totalItemSize }}</b-col>
          </b-row>
        </div>
        <div class="card-footer">
          <b-row> 
            <label for="name">Manifest Name</label>
            <input type="text" name="name" placeholder="Add Manifest Name" class="form-control" v-model="manifestName">
            <b-form-invalid-feedback :state="manifestName !== ''">
              Manifest name is required.
            </b-form-invalid-feedback>
          </b-row>
          <b-row>
            <label for="description">Manifest Description</label>
            <textarea name="description" v-model="manifestDescription" cols="25" rows="2" class="form-control" placeholder="Add Manifest Description"></textarea>
            <b-form-invalid-feedback :state="manifestDescription !== ''">
              Manifest description is required.
            </b-form-invalid-feedback>
          </b-row>
          <b-row class="createBtnRow">
            <b-button class="sm col-12" v-if="isSubmitted" variant="light">Saving...</b-button>
            <b-button class="sm col-12" v-else @click="createDataManifest" :disabled="this.cartItems.length === 0">Create Data Manifest</b-button>
          </b-row>
        </div>
      </div></b-col>
    </b-row>
  </b-container>
</template>

<script>
import EntityListGroupItem from '#/ui/Components/Entities/EntityListGroupItem.vue';
import { CreateManifestRequest } from '#/protobuf/service_ingest_pb';
import { Manifest } from '#/protobuf/manifest_pb';
import { EntityId } from '#/protobuf/entity_pb';

export default {
  components: { EntityListGroupItem },
  data() {
    return {
      manifestName: '',
      manifestDescription: '',
      isSubmitted: false,
    };
  },
  computed: {
    cartItems() {
      return this.$store.getters['datacart/cartItems'];
    },
    totalItemSize() {
      const cartItems = this.cartItems;
      let totalSize = 0;
      for (let index = 0; index < cartItems.length; index++) {
        const element = cartItems[index];
        if (element.size !== undefined) {
          totalSize = totalSize + element.size;
        } else if (element.bytes !== undefined) {
          totalSize = totalSize + element.bytes;
        }
      }
      return this.bytesToSize(totalSize);
    }
  },
  methods: {
    createDataManifest() {
      if (!this.manifestName || !this.manifestDescription) {
        console.warn('Manifest name is required.');
        return;
      }
      this.isSubmitted = true;
      const request = new CreateManifestRequest();
      // manifest.setManifestId(); // TODO: come back and implement a cart id system (for idempotency) at a later date
      request.setManifestName(this.manifestName);
      request.setManifestDescription(this.manifestDescription);
      for (let index = 0; index < this.cartItems.length; index += 1) {
        const cartItem = this.cartItems[index];
        console.log('adding cart item to manifest', cartItem);
        if (cartItem.itemType === 'job') {
          console.log('adding job id', cartItem.id);
          request.addJobIds(cartItem.id);
        } else {
          const entityId = new EntityId();
          entityId.setSize(cartItem.size);
          entityId.setChecksum(cartItem.checksum);
          console.log('adding entity id', entityId.toObject());
          request.addEntityIds(entityId);
        }
      }

      this.$store.dispatch('datacart/createManifest', request).then((response) => {
        const res = response.toObject();
        this.$store.dispatch('datacart/resetCart');
        this.$router.push({ path: `/manifests/${res.manifestId}`, project: this.$route.query.project });
      }).catch((error) => {
        console.log('promise rejected creating new manifest:', error);
        this.isSubmitted = false;
        this.$bvToast.toast(error, {
          title: 'Error in creating manifest',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        });
      }).finally(() => {
        this.isSubmitted = false;
      });
    },
    bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes == 0) return '0 Byte';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
  },
};
</script>

<style scoped>
.removeBtn{
  position: relative;
  z-index: 1;
  left: 0px;
}
.createBtnRow {
  padding-top: 10px;
}
</style>
